var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "loginPage" } }, [
    _vm._m(0),
    _c("div", { attrs: { id: "rightCardLogin" } }, [
      _vm._m(1),
      _c(
        "div",
        { attrs: { id: "loginForm" } },
        [
          _c("p", [_vm._v("Bienvenue ! Accédez à votre compte.")]),
          _c("validation-observer", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var handleSubmit = ref.handleSubmit
                  return [
                    _c(
                      "v-form",
                      {
                        on: {
                          submit: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return handleSubmit(_vm.onSubmit)
                          }
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "company", rules: { required: true } },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        id: "input-company",
                                        placeholder: "Code société",
                                        type: "text",
                                        trim: "",
                                        state: _vm.getValidationState(
                                          validationContext
                                        )
                                      },
                                      model: {
                                        value: _vm.form.company,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "company", $$v)
                                        },
                                        expression: "form.company"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          attrs: {
                            name: "warehouse",
                            rules: { required: true }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        id: "input-warehouse",
                                        placeholder: "Code site",
                                        type: "text",
                                        trim: "",
                                        state: _vm.getValidationState(
                                          validationContext
                                        )
                                      },
                                      model: {
                                        value: _vm.form.warehouse,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "warehouse", $$v)
                                        },
                                        expression: "form.warehouse"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          attrs: { name: "login", rules: { required: true } },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        id: "input-login",
                                        placeholder: "Identifiant",
                                        type: "text",
                                        trim: "",
                                        state: _vm.getValidationState(
                                          validationContext
                                        )
                                      },
                                      model: {
                                        value: _vm.form.login,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "login", $$v)
                                        },
                                        expression: "form.login"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          attrs: {
                            name: "password",
                            rules: { required: true }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        id: "input-password",
                                        placeholder: "Mot de passe",
                                        type: "password",
                                        trim: "",
                                        state: _vm.getValidationState(
                                          validationContext
                                        )
                                      },
                                      model: {
                                        value: _vm.form.password,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "password", $$v)
                                        },
                                        expression: "form.password"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("v-btn", { attrs: { type: "submit", block: "" } }, [
                          _vm._v("Connexion")
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "leftCardLogin" } }, [
      _c("canvas", { attrs: { id: "canvas" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "loginLogo" } }, [
      _c("img", {
        staticClass: "logo img-fluid",
        attrs: { src: require("@/assets/logo_tesfri_black.png"), alt: "TS" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }